import { RouteFactory } from "@app/routePaths";
import InfographicNews from "@routes/Article/components/Layout/InfographicNews";
import MainNewsDefault from "@routes/Article/components/Layout/MainNewsDefault";
import MainNewsDefaultForThrive from "@routes/Article/components/Layout/MainNewsDefaultForThrive";
import { ArticleDisplayType } from "@typings/enums";

type LayoutFactoryProps = {
  displayType?: string;
  path?: string;
};

const LayoutFactory = ({
  displayType = ArticleDisplayType.MainNewsDefault,
  path,
}: LayoutFactoryProps) => {
  if (path?.startsWith(RouteFactory.thrive)) return MainNewsDefaultForThrive;

  switch (displayType) {
    case ArticleDisplayType.Infographics:
      return InfographicNews;

    case ArticleDisplayType.MainNewsDefault:
    default:
      return MainNewsDefault;
  }
};

export default LayoutFactory;
